import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("no_token");
      return;
    }

    const verify = async () => {
      try {
        const res = await api.get(`/auth/verify-email?token=${token}`);

        if (res.data.message === "already_verified") {
          setStatus("already_verified");
          return;
        }

        // verified_now — refresh user in context + localStorage so wall disappears
        try {
          const meRes = await api.get("/auth/me");
          updateUser(meRes.data);
        } catch (_) {}

        setStatus("verified_now");
        setTimeout(() => navigate("/dashboard"), 3000);

      } catch (err) {
        const detail = err?.response?.data?.detail;
        if (detail === "already_verified_or_invalid") {
          setStatus("already_verified");
        } else {
          setStatus("error");
        }
      }
    };

    verify();
  }, [searchParams, navigate, updateUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "var(--secondary)" }}
    >
      <div
        className="bg-white rounded-xl border p-10 w-full max-w-md text-center"
        style={{ borderColor: "var(--border)" }}
      >
        {status === "verifying" && (
          <>
            <div className="spinner mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
              Verifying your email...
            </h1>
            <p className="opacity-70">Please wait a moment.</p>
          </>
        )}

        {status === "verified_now" && (
          <>
            <div className="text-4xl mb-4">✓</div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
              Email verified!
            </h1>
            <p className="opacity-70 mb-1">Your account is now active.</p>
            <p className="opacity-50 text-sm">Redirecting to your dashboard...</p>
          </>
        )}

        {status === "already_verified" && (
          <>
            <div className="text-4xl mb-4">✓</div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
              Already verified
            </h1>
            <p className="opacity-70 mb-6">
              Your email address has already been verified.
              You can sign in to access your dashboard.
            </p>
            <Link to="/login" className="btn-primary px-6 py-3 rounded-lg">
              Go to Login
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div className="text-4xl mb-4">✗</div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
              Verification failed
            </h1>
            <p className="opacity-70 mb-6">
              Something went wrong. Please sign in — if your email
              is still unverified you can request a new link from there.
            </p>
            <Link to="/login" className="btn-primary px-6 py-3 rounded-lg">
              Go to Login
            </Link>
          </>
        )}

        {status === "no_token" && (
          <>
            <div className="text-4xl mb-4">✗</div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
              Invalid link
            </h1>
            <p className="opacity-70 mb-6">
              This verification link is incomplete. Please use the full link from your email.
            </p>
            <Link to="/login" className="btn-primary px-6 py-3 rounded-lg">
              Go to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;